import { Media } from '@app/core/models/atomics.model';
import { GenericRequest } from '@app/core/models/request-status.model';
import { Price } from '@b2b/features/product/core/utilities/price.model';
import { GetStockResponse } from '@b2b/features/product/core/utilities/stock.model';

// prettier-ignore
export enum PRODUCT_MEDIA_TYPE {
  SUPER_ZOOM = 'superZoom', // 1200x1200
  ZOOM       = 'zoom',       // 515x515
  PRODUCT    = 'product',    // 300x300
  THUMBNAIL  = 'thumbnail',  // 96x96
  CART_ICON  = 'cartIcon',  // 65x65
  ICON       = 'icon',       // 30x30
}

export type ProductImageContainer = {
  [key in PRODUCT_MEDIA_TYPE]: Media;
};

export interface Video {
  src?: string;
}

export interface ProductMedias {
  images?: ProductImageContainer[];
  videos?: Video[];
}

export interface Specification {
  label: string;
  value: string;
}

export interface ProductStore {
  product: GenericRequest<Product>;
  price: GenericRequest<Price>;
  stock: GenericRequest<GetStockResponse>;
}

export interface FormattedProduct extends Omit<Product, 'factoryPrice' | 'invoiceAmount' | 'taxes'> {
  factoryPrice?: string;
  invoiceAmount?: string;
  taxes?: string;
  discount?: string;
  st?: string;
  empresa?: string;
  isTaxCalculated?: boolean;
}
export interface Product extends GetProductResponse {
  // Additional frontend-only fields
  code?: string;
  description?: string;
  name?: string;
  barcode?: string;
  medias?: ProductMedias;
  deliveryTime?: string;
  cutoffTime?: string | null;
  stock?: GenericRequest<GetStockResponse> | null;
  price?: GenericRequest<Price> | null;
}

export interface GetProductResponse {
  // Default fields
  id: string;

  // Core product fields
  code?: string;
  sapEAN?: string;
  name?: string;
  sapName?: string;
  description?: string;
  unit?: string;
  countryOrigin?: string;
  imageUrls?: string | string[];
  mediaUrls?: string | string[];

  // SAP fields
  sapConfigurable: boolean;
  manufacturerAID?: string | null;
  division?: string | null;
  productGroup?: string | null;
  externalProductGroup?: string | null;
  salesOrganization?: string | null;
  distributionChannel?: string | null;
  productHierarchy?: string | null;
  productType?: string | null;
  grossWeight?: number | null;
  materialGroup?: string | null;
  ncm?: string | null;
  useOfMaterial?: string | null;
  comissionGroup?: string | null;
  taxGroup?: string | null;
  brand?: string | null;
  merchandiseGroupDescription?: string | null;
  purchasingGroup?: string | null;
  plant?: string | null;
  valuationClass?: string | null;
  storageCondition?: string | null;
  sapCreatedAt?: string | Date | null;
  expirationDate?: string | Date | null;
}
